module.exports = __webpack_public_path__ + "img/JP.f4601af4.svg";